import "./style.scss";
import * as React from "react";
import { Switch } from "antd";

import { BarChart, LineChart } from "../Visualizations";
import { HeatmapLegend } from "../../../core/Chart/Heatmap";
import { FullscreenSpin } from "../Spin";
import SFML from "../SFML";

import {
  group_by_to_data_key_transformation,
  processGroupBy,
  defaultGroupBy,
  defaultView
} from "../../constants";

import { Flyer, FlyerItem } from "../../../core/Chart/Heatmap/types";

interface FullscreenViewState<T> {
  isSfmlHeat: T;
}

export interface FullscreenViewProps {
  metric: string;
  view: string;
  metricData: any[];
  metricDataLoading: boolean;
  flyer: Flyer;
  flyerLoading: boolean;
  flyerItems: FlyerItem[];
  flyerItemsLoading: boolean;
  groupBy: string;
  compareBy: string;
  usBased: boolean;
  onClose: () => void;
}

class FullscreenView extends React.Component<
  FullscreenViewProps,
  FullscreenViewState<boolean>
> {
  constructor() {
    super();
    this.state = {
      isSfmlHeat: true
    };
  }

  toggleSfmlHeat = () => {
    this.setState(prevState => ({ isSfmlHeat: !prevState.isSfmlHeat }));
  };

  renderVisualization = () => {
    const { groupBy, metric, metricData, compareBy, view, usBased } =
      this.props;

    switch (view) {
      case "bar":
        return (
          <BarChart
            group_by={group_by_to_data_key_transformation(
              metric,
              processGroupBy(groupBy, usBased)
            )}
            compare_by={compareBy}
            metric={metric}
            data={metricData}
            filterCompareBy={true}
            initialZoom={{ startIndex: 0, endIndex: 9 }}
            fullscreen={true}
          />
        );
      case "line":
        return (
          <LineChart
            group_by={group_by_to_data_key_transformation(
              metric,
              processGroupBy(groupBy, usBased)
            )}
            compare_by={compareBy}
            metric={metric}
            data={metricData}
            fullscreen={true}
          />
        );
      case "content":
        return (
          <div>
            <SFML fullscreen={true} />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    const { view, metricDataLoading, flyerLoading, flyerItemsLoading } =
      this.props;
    const loading =
      view == "content" ? flyerLoading || flyerItemsLoading : metricDataLoading;
    const classes = view === "content" ? "fullscreen heatmap" : "fullscreen";
    const display = view === "content" ? "flex" : null;
    return (
      <div>
        <div className="dark-overlay" />
        <div className={classes}>
          <div style={{ float: "right", display }}>
            {this.props.view == "content" && (
              <div style={{ display: "flex" }}>
                <div className="toggle-wrapper">
                  <div className="toggle">
                    <h3 style={{ marginTop: 20, marginBottom: 5 }}>
                      TOGGLE HEATMAP
                    </h3>
                    <Switch
                      className="toggle-fullscrean-heatmap"
                      checked={this.state.isSfmlHeat}
                      onChange={this.toggleSfmlHeat}
                    />
                  </div>
                </div>
                <div style={{ paddingRight: 35, paddingTop: 17 }}>
                  <HeatmapLegend />
                </div>
              </div>
            )}
            <div className="close-button" title="Close">
              <img
                src="/icon-close.svg"
                onClick={this.props.onClose}
                style={{
                  width: 25,
                  height: 25,
                  marginTop: 30,
                  marginRight: 30
                }}
              />
            </div>
          </div>

          <div>{loading ? <FullscreenSpin /> : null}</div>

          <div className="metrics-visualization">
            {this.renderVisualization()}
          </div>
        </div>
      </div>
    );
  }
}
export default FullscreenView as any;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/FullscreenView/component.tsx